import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import WhatIsSection from './components/WhatIsSection';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import SafetySection from './components/SafetySection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import ArticleSection from './components/ArticleSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <TrustBadges />
      <WhatIsSection />
      <WhySection />
      <CategoryGrid />
      <CTASection />
      <TestimonialSection />
      <ArticleSection />
      <Footer />
    </main>
  );
}